export const init = async function() {
    const observerConfig = {
        subtree: true,
        childList: true,
        attributes: true
    };
    const observer = new MutationObserver(()=>{
        const activeSwatch = document.querySelector('.Product-colorSwatch.active');
        var _activeSwatch_dataset_labelToHide;
        const hide = activeSwatch instanceof HTMLElement ? (_activeSwatch_dataset_labelToHide = activeSwatch.dataset.labelToHide) !== null && _activeSwatch_dataset_labelToHide !== void 0 ? _activeSwatch_dataset_labelToHide : null : null;
        if (!hide) {
            return;
        }
        const dimmedButtons = document.querySelectorAll('.ProductRadioButtons-group .ProductRadioButtons-itemLabel--dimmed');
        const hideVariants = hide.toLowerCase().split('-');
        const childVariant = hideVariants[1];
        const hideButton = function(button) {
            const parentItem = button.closest('.ProductRadioButtons-item');
            if (parentItem instanceof HTMLElement) {
                parentItem.style.display = 'none';
            }
        };
        const showButton = function() {
            const childVariants = document.getElementsByClassName('ProductRadioButtons-groupItems')[1];
            var _childVariants_querySelectorAll;
            const hiddenButtons = (_childVariants_querySelectorAll = childVariants === null || childVariants === void 0 ? void 0 : childVariants.querySelectorAll('[style*="display: none"]')) !== null && _childVariants_querySelectorAll !== void 0 ? _childVariants_querySelectorAll : [];
            hiddenButtons.forEach((elem)=>{
                if (elem instanceof HTMLElement) {
                    elem.style.display = 'block';
                }
            });
        };
        dimmedButtons.forEach((button)=>{
            const hideVariant = button instanceof HTMLElement ? button.innerText.toLowerCase() : '';
            if (childVariant) {
                var _document_getElementsByClassName__querySelector, _document_getElementsByClassName_;
                const selectedSize = (_document_getElementsByClassName__querySelector = (_document_getElementsByClassName_ = document.getElementsByClassName('ProductRadioButtons-groupItems')[0]) === null || _document_getElementsByClassName_ === void 0 ? void 0 : _document_getElementsByClassName_.querySelector('.ProductRadioButtons-itemLabel--checked')) === null || _document_getElementsByClassName__querySelector === void 0 ? void 0 : _document_getElementsByClassName__querySelector.innerText;
                if ((hideVariant === hide || hideVariant === childVariant) && (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.toLowerCase()) === hideVariants[0]) {
                    hideButton(button);
                } else {
                    showButton();
                }
            } else if (hideVariant === hide) {
                hideButton(button);
            }
        });
    });
    observer.observe(document.documentElement, observerConfig);
};
